import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Route, Switch } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

import store from 'root/admin/store';

@observer
export default class CouncilSessions extends React.Component {

	render() {
		const rootPath = '/admin';
		return (
			<Switch>
				<Route path="/admin/councilsessions" exact component={() => <List rootPath={rootPath} />} />
				<Route path="/admin/councilsessions/create" component={() => <Edit rootPath={rootPath} />} />
				<Route path="/admin/councilsessions/:id" component={() => <Edit rootPath={rootPath} />} />
			</Switch>
		);
	}
}
